/* eslint-disable no-unused-vars */

import { useEffect, useState, useRef } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Loading from '@components/loading/loading.component';

import routeLists from './route-list';
import CacheService from '@services/cache.service';
import MigrationSelector from 'selectors/migration';

export default function MyRoutes() {
  const [loading, setLoading] = useState(process.env.NODE_ENV !== 'development');
  const caching = useSelector((state) => state.cache.caching);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);

      if (localStorage.getItem('getNewDataAfterUpdate') === 'true' && !caching) {
        localStorage.setItem('getNewDataAfterUpdate', false);
        CacheService.refresh({
          initialCache: true,
          initialLogin: true,
          updateApp: true
        });
      }
    }, 11000);

    return () => {
      clearTimeout();
    };
  }, [localStorage.getItem('getNewDataAfterUpdate'), caching]);

  useEffect(() => {
    setTimeout(async () => {
      if (localStorage.getItem('deleteDB') === 'true') {
        localStorage.removeItem('deleteDB');

        await MigrationSelector.deleteDB();
      }
    }, 4000);

    return () => {
      clearTimeout();
    };
  }, [localStorage.getItem('deleteDB')]);

  const router = createBrowserRouter(routeLists());

  return (
    <>{loading ? <Loading /> : <RouterProvider router={router} fallbackElement={<Loading />} />}</>
  );
}
